import React, { useEffect, useState } from 'react';
import { Nav, Card, Collapse, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { FaPrint } from 'react-icons/fa';
import PublicHeader from '../CommonUtils/PublicHeader';
import { FaCaretDown } from "react-icons/fa";
import { MdArrowRight } from 'react-icons/md';
import PublicFooter from '../CommonUtils/PublicFooter';
import { FaArrowRightArrowLeft } from "react-icons/fa6";
import { config } from '../CommonUtils/CommonURLS';
import { CommonAxiosGet } from '../CommonUtils/CommonAxios';

const Menu = ({ children }) => {
    const [services, setMenuData] = useState(null);
    const [openSection, setOpenSection] = useState(sessionStorage.getItem('openSection') || null);
    const [activeSection, setActiveSection] = useState(sessionStorage.getItem('activeSection') || null);
    const [activeChild, setActiveChild] = useState(sessionStorage.getItem('activeChild') || null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const Collegetype = sessionStorage.getItem('loginType');
    const userId = sessionStorage.getItem('user_id');

    const buildServiceTree = (services) => {
        const serviceMap = {};
        const serviceTree = [];
        services?.forEach(service => {
            serviceMap[service?.service_id] = {
                ...service,
                children: []
            };
        });
        services?.forEach(service => {
            if (service?.parent_id === -1 || service?.parent_id === 0) {
                serviceTree.push(serviceMap[service.service_id]);
            } else if (serviceMap[service?.parent_id]) {
                serviceMap[service?.parent_id].children.push(serviceMap[service?.service_id]);
            }
        });
        return serviceTree;
    };

    const demoLinks = buildServiceTree(services);

    const toggleSection = (link) => {
        setActiveSection(link?.service_name);
        sessionStorage.setItem('activeSection', link?.service_name);

        if (!link?.children || link?.children.length === 0) {
            setOpenSection(null);
            setActiveChild(null);
            sessionStorage.removeItem('openSection');
            sessionStorage.removeItem('activeChild');

            if (link?.target) {
                window.location.href = link.target;
            }
        } else {
            const newOpenSection = openSection === link?.service_name ? null : link?.service_name;
            setOpenSection(newOpenSection);
            sessionStorage.setItem('openSection', newOpenSection);
        }
    };

    const handleChildClick = (parentName, childName) => {
        setOpenSection(parentName);
        setActiveChild(childName);
        sessionStorage.setItem('openSection', parentName);
        sessionStorage.setItem('activeChild', childName);
    };

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    useEffect(() => {
        const fetchData = () => {
            const data = sessionStorage.getItem('menuData');
            if (data) {
                setMenuData(JSON.parse(data));
            }
        };
        fetchData();
        const intervalId = setInterval(fetchData, 100);
        return () => clearInterval(intervalId);
    }, []);


    const [payment, setpayment] = useState('');
    function GetPaymentStatus() {
        CommonAxiosGet(config.url.API_URL + 'getpaymentCheck').then((res) => {
            if (res?.data?.scode === '01') {
                setpayment(res?.data?.payment);

            }
            else {
                setpayment('')
            }
        })
    }

    const [ffcastatus, setFfcastatus] = useState([]);
    function GetffcaStatus() {
        CommonAxiosGet(config.url.API_URL + 'getcollegeffcastatus/' + userId).then((res) => {
            if (res?.data?.scode === '01') {
                setFfcastatus(res?.data?.ffcaStatus);

            }
            else {
                setFfcastatus('')
            }
        })
    }

    useEffect(() => {
        if (Collegetype === "college") {
            GetffcaStatus();
        }
        GetPaymentStatus();
    }, [])
    return (
        <>
            <PublicHeader />
            <div className="containerr">
                {(Collegetype === "college" ? (payment === "done") : true) && (<>
                    <div className={`sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
                        <button className="sidebar-toggle-btn" onClick={toggleSidebar}>
                            <FaArrowRightArrowLeft />
                        </button>
                        <ul className="menu">
                            {(ffcastatus !== '' && ffcastatus !== undefined && ffcastatus !== null && ffcastatus === "0") || Collegetype === "ffca" || Collegetype === "university" ? (<>
                                <div>
                                    <Nav defaultActiveKey="/application-details" className="flex-column no-border sidebar-content" style={{ backgroundColor: 'white' }}>
                                        {demoLinks && demoLinks?.map((link, index) => (
                                            <div key={index} style={{ border: 'none' }}>
                                                <Card className="no-border">

                                                    <Card.Header
                                                        onClick={() => toggleSection(link)}
                                                        style={{
                                                            cursor: 'pointer',
                                                            padding: '10px',
                                                            backgroundColor: activeSection === link?.service_name ? '#5e5e5e' : "#262626",
                                                            color: '#fff',
                                                            border: 'none',
                                                            borderRadius: '0'
                                                        }}>

                                                        <OverlayTrigger
                                                            placement="right"
                                                            overlay={
                                                                !isSidebarOpen ? (
                                                                    <Tooltip id={`tooltip-${link.service_id}`} className="affltool-tip">
                                                                        {link?.service_name}
                                                                    </Tooltip>
                                                                ) : <></>
                                                            }
                                                        >

                                                            <div className='menu-subtext position-relative'>
                                                                {link?.id === 3435 && <FaPrint />}

                                                                <div className='menu-text'>
                                                                    <div dangerouslySetInnerHTML={{ __html: '&emsp;' + (link?.icon_html || '') }} ></div>
                                                                    <p className='mb-0' dangerouslySetInnerHTML={{ __html: '' + (link?.service_name || '') }} ></p>

                                                                </div>
                                                                < FaCaretDown className='affldown-arrow' />

                                                            </div>

                                                        </OverlayTrigger>

                                                    </Card.Header>

                                                    {link?.children && link?.children.length > 0 && (
                                                        <Collapse in={openSection === link.service_name}>
                                                            <Card.Body style={{ padding: '0', backgroundColor: '#e5e8e8', border: 'none' }}>
                                                                {link?.children.map((child, childIndex) => (
                                                                    <Nav.Link
                                                                        key={childIndex}
                                                                        // href={child?.target}
                                                                        href={child?.target?.startsWith('/') ? child.target : '/' + child.target}

                                                                        onClick={() => handleChildClick(link.service_name, child?.service_name)}
                                                                        className={`custom-nav-link no-border ${activeChild === child?.service_name ? 'active-child' : ''}`}>
                                                                        <p className='mb-0 affl-chileserve'> < MdArrowRight />   {child?.service_name}</p>
                                                                    </Nav.Link>
                                                                ))}
                                                            </Card.Body>
                                                        </Collapse>
                                                    )}
                                                </Card>
                                            </div>
                                        ))}
                                    </Nav>

                                </div>

                            </>) : (<></>)}
                        </ul>

                    </div>

                    <div className={`content ${isSidebarOpen ? 'content-shifted' : ''}`}>
                        {children}
                    </div>

                </>)}

            </div >
            <PublicFooter />
        </>
    );
};

export default Menu;
